import { useQuery, useMutation } from "@tanstack/react-query";
import api from "../axios-client";
import { queryClient } from "../query-client";

export const useGetAllUsers = () => {
    return useQuery({
        queryKey: ["users"],
        queryFn: async () => {
            const response = await api.get("/api/v1/users");
            return response.data.data;
        },
        retry: false,
        staleTime: 1000 * 60 * 60,
    });
};

export const usePatchUser = () =>
    useMutation({
        mutationFn: async ({ id, data }: { id: string; data: any }) => {
            const response = await api.patch(`/api/v1/users/${id}`, data);
            return response.data.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["users"] });
        },
    });

export const useInviteUser = () =>
    useMutation({
        mutationFn: async (data: { email: string; firstName: string; lastName: string; role: string; businessId?: string | null }) => {
            const response = await api.post("/api/v1/auth/invite", data);
            return response.data.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["users"] });
        },
    });
